<template>
    <a-button :type="getType"
              :loading="loading"
              :disabled="disabled"
              :class="[getTypeClass, this.size]"
              @click="$emit('click')">
      <slot v-if="!text"></slot>
      {{text}}
    </a-button>
</template>

<script>

export default {
  props: {
    text: String,
    type: {
      default: 'default'
    },
    size: {
      default: 'default'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    round: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      supportTypes: ['primary', 'ghost', 'dashed', 'danger', 'link']
    }
  },
  computed: {
    getType() {
      if (this.supportTypes.includes(this.type)) {
        return this.type
      }
      return null
    },
    getTypeClass() {
      if (this.supportTypes.includes(this.type)) {
        return ''
      }
      return `ant-btn-${this.type}`
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./styles.scss"
</style>